import React, { useState } from 'react'
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { ReactComponent as Back } from '../images/back.svg'
import { ReactComponent as Burger } from '../images/burger.svg'
import { ReactComponent as CloseIcon } from '../images/close-icon.svg'
import { ReactComponent as Home } from '../images/home.svg'
import { ReactComponent as Stones } from '../images/stones.svg'
import { ReactComponent as Sleep } from '../images/sleep.svg'
import { ReactComponent as Music } from '../images/music-icon.svg'
import { ReactComponent as Food } from '../images/nutrition.svg'
import Info from '../images/info.png'

const NavBar = ({ hovers, ...props }) => {
  const location = useLocation()
  const history = useHistory()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const NavWrapper = styled.div``

  const NavBar = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 3rem auto;
    width: 85%;
  `

  const SidebarNav = styled.div`
    align-items: center;
    background: #efefef;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    position: fixed;
    top: 0;
    right: -16rem;
    width: 16rem;
    z-index: 9;

    &.open {
      right: 0;
    }
  `

  const NavButtonShared = `
  background: none;
    border: 0;
    cursor: pointer;
    display: ${location.pathname === `/` ? `none` : `flex`};
  `

  const BackButton = styled.button`
    ${NavButtonShared}
  `

  const BurgerButtonHover = `
  &:hover {
    transform: rotate(90deg);
  }
  `

  const BurgerButton = styled.button`
    transition: transform 0.25s;
    ${NavButtonShared}

    ${hovers ? BurgerButtonHover : ``}
  `

  const SidebarClose = styled.button`
    border: 0;
    cursor: pointer;
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
  `

  const SidebarLink = styled(NavLink)`
    align-items: center;
    border-bottom: 1px solid black;
    color: #3b3b3b;
    display: flex;
    font-family: 'museo-sans', sans-serif;
    font-weight: 700;
    justify-content: center;
    padding: 3rem 0;
    text-decoration: none;
    width: 70%;

    &:last-child {
      border-bottom: none;
    }

    svg {
      height: auto;
      padding-right: 1rem;
      width: auto;
    }
  `

  return (
    <NavWrapper>
      <NavBar>
        <BackButton onClick={() => history.goBack()}>
          <Back />
        </BackButton>
        <BurgerButton
          onClick={() => {
            console.log('click')
            setSidebarOpen(true)
          }}
        >
          <Burger />
        </BurgerButton>
      </NavBar>
      <SidebarNav className={sidebarOpen && 'open'}>
        <SidebarClose
          onClick={() => {
            console.log('click')
            setSidebarOpen(false)
          }}
        >
          <CloseIcon style={{ height: `1rem`, width: `1rem` }} />
        </SidebarClose>
        <SidebarLink exact to="/">
          <Home />
          Home
        </SidebarLink>
        <SidebarLink exact to="/stressrelief">
          <Stones />
          Stress Relief
        </SidebarLink>
        <SidebarLink exact to="/sleep">
          <Sleep />
          Sleep
        </SidebarLink>
        <SidebarLink exact to="/music">
          <Music />
          Music
        </SidebarLink>
        <SidebarLink exact to="/nutrition">
          <Food />
          Nutrition
        </SidebarLink>
      </SidebarNav>
    </NavWrapper>
  )
}

export default NavBar
